<template>
    <el-card>
        <div slot="header">
            <span style="font-size: 18px; font-weight: bold">产品尺寸</span>
        </div>
        <div class="product-size-container">
            <!-- 左侧产品型号列表 -->
            <div class="chip-model-list">
                <div class="list-title">产品型号</div>
                <el-empty v-if="productList.length === 0 && !modelLoading" description="暂无产品型号" />
                <div v-else class="model-scroll" @scroll="handleModelScroll">
                    <el-menu :default-active="activeProduct" class="product-menu" @select="handleProductSelect" >
                        <el-menu-item v-for="product in productList" :key="String(product.id)" :index="String(product.id)" >
                            <div class="product-item">
                                <span class="product-name">{{ product.name }}</span>
                            </div>
                        </el-menu-item>
                    </el-menu>
                    <div class="load-more">
                        <span v-if="modelLoading">加载中...</span>
                        <span v-else-if="hasMoreModels">上滑加载更多</span>
                        <span v-else-if="productList.length">已加载全部 {{ modelTotal }} 个</span>
                    </div>
                </div>
            </div>

            <!-- 右侧尺寸表 -->
            <div class="size-table-wrapper">
                <div class="table-header">
                    <div class="table-title">{{ tableTitle }}</div>
                    <el-button type="primary" size="small" @click="openAddDialog">增加尺寸配置</el-button>
                </div>
                <el-empty v-if="!activeProduct" description="请先选择左侧产品型号" />
                <el-empty v-else-if="sizeList.length === 0 && !sizeLoading" description="暂无尺寸数据" />
                <el-table v-else :data="sizeList" v-loading="sizeLoading" border stripe style="width: 100%" :fit="true" >
                    <el-table-column prop="code" label="尺寸编码" align="center" min-width="100" />
                    <el-table-column prop="name" label="尺寸名称" align="center" min-width="100" />
                    <el-table-column prop="length" label="长度(m)" align="center" min-width="100" /> 
                    <el-table-column prop="width" label="宽度(m)" align="center" min-width="100" />
                    <el-table-column prop="height" label="高度(m)" align="center" min-width="100" />
                    <el-table-column prop="basePriceInner" label="内部价格(元)" align="center" min-width="120" />
                    <el-table-column prop="basePriceOut" label="外部价格(元)" align="center" min-width="120" />
                    <el-table-column label="操作" align="center" min-width="120" fixed="right" >
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="handleEdit(scope.row)" >编辑</el-button>
                            <el-button type="text" size="small" @click="handleDelete(scope.row)" style="color: #f56c6c">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination-container">
                    <el-pagination v-if="activeProduct" background layout="total, sizes, prev, pager, next, jumper" :total="total" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]" :current-page="currentPage" @size-change="handleSizeChange" @current-change="handlePageChange" />
                </div>
            </div>
        </div>

        <!-- 尺寸配置弹窗（新增/编辑共用） -->
        <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogVisible"
            width="500px"
            :close-on-click-modal="false"
        >
            <el-form ref="form" :model="form" label-width="120px" :rules="formRules" >
                <el-form-item label="产品型号">
                    <el-input v-model="form.productModel" disabled />
                </el-form-item>
                <el-form-item label="尺寸编码" prop="code">
                    <el-input v-model="form.code" placeholder="请输入尺寸编码" />
                </el-form-item>
                <el-form-item label="尺寸名称" prop="name">
                    <el-input v-model="form.name" placeholder="请输入尺寸名称" />
                </el-form-item>
                <el-form-item label="长度(m)" prop="length">
                    <el-input v-model="form.length" placeholder="请输入长度" />
                </el-form-item>
                <el-form-item label="宽度(m)" prop="width">
                    <el-input v-model="form.width" placeholder="请输入宽度" />
                </el-form-item>
                <el-form-item label="高度(m)" prop="height">
                    <el-input v-model="form.height" placeholder="请输入高度" />
                </el-form-item>
                <el-form-item label="内部价格(元)" prop="basePriceInner">
                    <el-input v-model="form.basePriceInner" placeholder="请输入内部价格" />
                </el-form-item>
                <el-form-item label="外部价格(元)" prop="basePriceOut">
                    <el-input v-model="form.basePriceOut" placeholder="请输入外部价格" />
                </el-form-item>
                <el-form-item label="排序" prop="sortOrder">
                    <el-input-number v-model="form.sortOrder" :min="0" :max="9999" controls-position="right" />
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    <el-select v-model="form.status" placeholder="请选择状态" style="width: 100%">
                        <el-option label="禁用" :value="0" />
                        <el-option label="启用" :value="1" />
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit">确 定</el-button>
            </div>
        </el-dialog>
    </el-card>
</template>

<script>
import { productModelList, productSizeList, productSizeAdd, productSizeUpdate, productSizeDelete } from '@/api/quote'

export default {
    name: 'QuoteSize',
    data() {
        return {
            activeProduct: '',
            currentPage: 1,
            pageSize: 10,
            total: 0,
            sizeLoading: false,
            modelPage: 1,
            modelPageSize: 10,
            modelTotal: 0,
            modelLoading: false,
            dialogVisible: false,
            dialogTitle: '增加尺寸配置',
            isEdit: false,
            form: {
                productModel: '',
                code: '',
                name: '',
                length: '',
                width: '',
                height: '',
                basePriceInner: '',
                basePriceOut: '',
                sortOrder: 0,
                status: 1
            },
            editId: null,
            formRules: {
                code: [{ required: true, message: '请输入尺寸编码', trigger: 'blur' }],
                name: [{ required: true, message: '请输入尺寸名称', trigger: 'blur' }],
                length: [{ required: true, message: '请输入长度', trigger: 'blur' }],
                width: [{ required: true, message: '请输入宽度', trigger: 'blur' }],
                height: [{ required: true, message: '请输入高度', trigger: 'blur' }],
                basePriceInner: [{ required: true, message: '请输入内部价格', trigger: 'blur' }],
                basePriceOut: [{ required: true, message: '请输入外部价格', trigger: 'blur' }]
            },
            productList: [],
            sizeList: []
        }
    },
    computed: {
        tableTitle() {
            if (!this.activeProduct) return '尺寸表'
            const product = this.productList.find(item => String(item.id) === this.activeProduct)
            return product ? `${product.name} - 尺寸表` : '尺寸表'
        },
        hasMoreModels() {
            return this.productList.length < this.modelTotal
        }
    },
    mounted() {
        this.getProductModelList()
    },
    methods: {
        // 获取产品型号列表（左侧菜单，滚动分页，append 时追加下一页）
        getProductModelList(append = false) {
            if (this.modelLoading) return
            this.modelLoading = true
            productModelList({
                filter: [],
                sorted: [{ name: 'sortOrder', type: 'ASC' }],
                current: this.modelPage,
                size: this.modelPageSize
            }).then(res => {
                if (res && res.success && res.result) {
                    const records = res.result.records || []
                    this.productList = append ? this.productList.concat(records) : records
                    this.modelTotal = res.result.total 
                }
            }).catch(error => {
                console.error('获取产品型号列表失败：', error)
            }).finally(() => {
                this.modelLoading = false
            })
        },
        // 左侧列表滚动到底部时加载下一页
        handleModelScroll(event) {
            const el = event.target
            if (el.scrollTop + el.clientHeight >= el.scrollHeight - 40) {
                this.loadMoreModels()
            }
        },
        // 加载下一页（追加到列表尾部）
        loadMoreModels() {
            if (this.modelLoading || !this.hasMoreModels) return
            this.modelPage += 1
            this.getProductModelList(true)
        },
        // 根据产品型号ID获取尺寸列表（后端分页）
        getProductSizeList() {
            if (!this.activeProduct) {
                this.sizeList = []
                this.total = 0
                return
            }
            this.sizeLoading = true
            productSizeList({
                filter: [ { name: 'modelId', value: this.activeProduct, type: 'EQ' } ],
                sorted: [{ name: 'sortOrder', type: 'ASC' }],
                current: this.currentPage,
                size: this.pageSize
            }).then(res => {
                if (res && res.success && res.result) {
                    this.sizeList = res.result.records || []
                    this.total = res.result.total || 0
                } else {
                    this.sizeList = []
                    this.total = 0
                    this.$message.error((res && res.message) || '获取尺寸列表失败')
                }
            }).catch(error => {
                console.error('获取尺寸列表失败：', error)
                this.sizeList = []
                this.total = 0
                this.$message.error('获取尺寸列表失败')
            }).finally(() => {
                this.sizeLoading = false
            })
        },
        // 处理产品型号选择
        handleProductSelect(index) {
            this.activeProduct = index
            this.currentPage = 1
            this.getProductSizeList()
        },
        // 处理每页条数变化
        handleSizeChange(size) {
            this.pageSize = size
            this.currentPage = 1
            this.getProductSizeList()
        },
        // 处理分页变化
        handlePageChange(page) {
            this.currentPage = page
            this.getProductSizeList()
        },

        // 打开增加尺寸配置弹窗
        openAddDialog() {
            if (!this.activeProduct) {
                this.$message.warning('请先选择左侧产品型号')
                return
            }
            const product = this.productList.find(item => String(item.id) === this.activeProduct)
            this.form.productModel = product ? `${product.code}-${product.name}` : ''
            this.form.code = ''
            this.form.name = ''
            this.form.length = ''
            this.form.width = ''
            this.form.height = ''
            this.form.basePriceInner = ''
            this.form.basePriceOut = ''
            this.form.sortOrder = 0
            this.form.status = 1
            this.dialogTitle = '增加尺寸配置'
            this.isEdit = false
            this.editId = null
            this.dialogVisible = true
        },
        // 编辑尺寸配置
        handleEdit(row) {
            const product = this.productList.find(item => String(item.id) === this.activeProduct)
            this.form.productModel = product ? `${product.code}-${product.name}` : ''
            this.form.code = row.code
            this.form.name = row.name
            this.form.length = row.length
            this.form.width = row.width
            this.form.height = row.height
            this.form.basePriceInner = row.basePriceInner
            this.form.basePriceOut = row.basePriceOut
            this.form.sortOrder = row.sortOrder !== undefined ? row.sortOrder : 0
            this.form.status = row.status !== undefined ? row.status : 1
            this.dialogTitle = '编辑尺寸配置'
            this.isEdit = true
            this.editId = row.id
            this.dialogVisible = true
        },
        // 提交尺寸配置
        handleSubmit() {
            this.$refs.form.validate(async valid => {
                if (!valid) return

                const sizeData = {
                    code: this.form.code,
                    name: this.form.name,
                    length: this.form.length,
                    width: this.form.width,
                    height: this.form.height,
                    basePriceInner: this.form.basePriceInner,
                    basePriceOut: this.form.basePriceOut,
                    sortOrder: this.form.sortOrder,
                    status: this.form.status
                }

                try {
                    let res
                    if (this.isEdit) {
                        sizeData.id = this.editId
                        res = await productSizeUpdate(sizeData)
                    } else {
                        sizeData.modelId = this.activeProduct
                        res = await productSizeAdd(sizeData)
                    }

                    if (res && res.code === '0000') {
                        this.$message.success(this.isEdit ? '修改成功' : '添加成功')
                        if (this.isEdit) {
                            this.getProductSizeList()
                        } else {
                            this.currentPage = 1
                            this.getProductSizeList()
                        }
                        this.dialogVisible = false
                    } else {
                        this.$message.error(res.message || (this.isEdit ? '修改失败' : '添加失败'))
                    }
                } catch (error) {
                    console.error(this.isEdit ? '修改尺寸失败：' : '添加尺寸失败：', error)
                    this.$message.error(this.isEdit ? '修改失败' : '添加失败')
                }
            })
        },
        handleDelete(row) {
            this.$confirm('确认删除该尺寸配置?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    const res = await productSizeDelete(row.id)
                    if (res && res.code === '0000') {
                        this.$message.success('删除成功')
                        if (this.sizeList.length === 1 && this.currentPage > 1) {
                            this.currentPage -= 1
                        }
                        this.getProductSizeList()
                    } else {
                        this.$message.error(res.message || '删除失败')
                    }
                } catch (error) {
                    console.error('删除尺寸失败：', error)
                    this.$message.error('删除失败')
                }
            }).catch(() => {})
        }
    }
}
</script>

<style scoped>
.product-size-container {
    display: flex;
    gap: 20px;
    min-height: 500px;
    flex-wrap: nowrap;
}

.chip-model-list {
    width: 260px;
    min-width: 260px;
    flex-shrink: 0;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

/* 左侧产品型号列表滚动容器：滚动到底部时加载下一页 */
.model-scroll {
    flex: 1;
    max-height: 480px;
    overflow-y: auto;
}

.load-more {
    padding: 10px 0;
    text-align: center;
    font-size: 12px;
    color: #909399;
}

.list-title {
    padding: 15px;
    font-size: 16px;
    font-weight: bold;
    color: #303133;
    background-color: #f5f7fa;
    border-bottom: 1px solid #ebeef5;
}

.product-menu {
    border-right: none;
}

.product-menu .el-menu-item {
    height: auto;
    line-height: 1.5;
    padding: 12px 20px !important;
}

.product-item {
    display: flex;
    align-items: center;
    gap: 4px;
}

.product-name {
    font-size: 14px;
    color: #606266;
}

.size-table-wrapper {
    flex: 1;
    min-width: 0;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 20px;
    background-color: #fff;
    overflow-x: auto;
}

.table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #ebeef5;
}

.table-title {
    font-size: 16px;
    font-weight: bold;
    color: #303133;
}

.pagination-container {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #1890ff;
}
</style>